<template>
  <a :href="href" :data-event-tracking="dataEventTracking">
    <div @click.prevent="openBrowser" :data-event-tracking="dataEventTracking">
      <slot></slot>
    </div>
  </a>
</template>

<script>
import { Browser } from "@capacitor/browser";
export default {
  name: "InAppBrowser",
  props: {
    href: {
      type: String,
    },
    dataEventTracking: {
      type: String,
      default: "",
    },
    page: {
      type: String,
      default: "",
    },
  },
  methods: {
    getPage() {
      if (this.page) return this.page;
      return this.$route.path.split("/").pop();
    },
    openBrowser() {
      this.$emit("log-event");
      // this.$router.push(
      //   `/url?q=${encodeURIComponent(this.href)}&from=${this.$route.path}`
      // );
      Browser.open({
        url: this.href,
      });
    },
  },
};
</script>
